/**
 * EM QUE CAIXA a equipe responde sem ser a dona da conversa.
 *
 * Pedido do Ruan em 26/08/2026, com dois prints lado a lado — o dele com as ferramentas
 * do chat e o do JOAO sem nada: *"O JOAO nao tem as ferramentas do canto inferior
 * esquerdo. Tem como habilitar para todos os usuarios da loja com acesso ao app"*.
 * Nao faltavam ferramentas: faltava o compositor INTEIRO, porque a conversa do print
 * era da CRISTINA e a [DA-027] deixa so a dona responder. O motivo que ele deu fecha a
 * questao — *"as vezes o cliente chamou o usuario pelo whatsapp pessoal, como foi o
 * caso, o orcamento era pro tio dele"*: no AppCel quem conhece o cliente costuma nao
 * ser quem o rodizio sorteou.
 *
 * ## Por que uma peca so
 *
 * A mesma pergunta era respondida em TRES lugares — `checarPermissaoConversa` no
 * servidor, o `PainelChat` do ERP e o `ChatAtender` da loja no celular — e cada um
 * escrevia a lista de caixas na mao. Tres copias sao tres lugares pra divergir, e a
 * divergencia ja tinha cobrado uma vez: na [DA-539] o front testava `=== 'atendimento'`
 * enquanto o servidor liberava so `compras`, e a vendedora via o campo de digitar aberto
 * numa conversa que voltava 403 no clique. Mesma receita do [[apagar-mensagem]] e do
 * [[marca-loja]]: as duas pontas precisam da MESMA resposta por motivos diferentes — a
 * tela decide se desenha o compositor, o servidor recusa de verdade.
 *
 * ## A lista e' de CAIXAS, nunca de perfis
 *
 * ⛔ O que libera e' a caixa, nao quem esta olhando. `compras` e' o numero pessoal do
 * Ruan e nunca teve rodizio; `app` e' o AppCel, onde todo mundo da loja **ja ve** todas
 * as conversas desde a [DA-539] — e ver sem poder responder era justamente a metade que
 * travava o trabalho. `atendimento` continua fechada na dona: la o rodizio responde
 * "de quem foi este chamado", e isso alimenta carga e estatistica ([DA-027], RDS 1.8).
 *
 * ⚠️ **Isto NAO toma posse.** Quem responde uma conversa que nao e' dele assina com o
 * proprio nome e a conversa **continua com quem era** — decisao dele na mesma conversa:
 * *"Nao, o Contato nao muda de dono"*. E' a regra que o celular BALCAO ja seguia desde
 * 15/08/2026, agora valendo pras contas da equipe. Admin e gerente seguem ASSUMINDO ao
 * responder (takeover da RDS 1.14), porque isso ninguem pediu pra mudar — e por isso o
 * ramo deles vem ANTES deste no servidor.
 */

/** A caixa `atendimento`, unica em que responder exige ser a dona da conversa. */
export const INBOX_SO_DA_DONA = 'atendimento';

/**
 * Nesta caixa, qualquer conta da equipe responde sem ser a dona da conversa?
 *
 * ⚠️ Escrito como lista do que LIBERA, nunca como `!== 'atendimento'`. Uma quarta caixa
 * que nasca amanha entra fechada e alguem tem que decidir abri-la — o avesso deixaria
 * ela livre por acidente, que e' o modo caro de errar ([DA-481]: a guarda pergunta o que
 * ela quer garantir, nao qual nome estava a mao).
 */
export function equipeRespondeSemSerDona(inbox: string): boolean {
  return inbox === 'compras' || inbox === 'app';
}
